<template>
<div>
</div>
</template>

<script>

export default {
  data() {
    return {

    };
  },

  methods: {
    init(){
      let params =  this.$route.params.params;
      params = decodeURIComponent(params);
      params = JSON.parse(params);
      let storage = {};
      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const element = params[key];
          storage[key] = element;
        }
      }

      let sbzRegion = localStorage.getItem('sbzRegion')
      let keyword = localStorage.getItem('keyword')
      let position = localStorage.getItem('position')
       let info = localStorage.getItem("info");
       let items = localStorage.getItem("items");
      localStorage.clear();
      if(sbzRegion){
        storage['sbzRegion'] = sbzRegion;
      }
      if(keyword){
        storage['keyword'] = keyword;
      }
      if(position){
        storage['position'] = position;
      }
       if(info){
        storage['info'] = info;
      }
       if(items){
        storage['items'] = items;
      }
      this.$util.setSessionStorage(storage);
      if(params.return_url){
        this.$router.replace({ path: params.return_url });
      }
      else{
        this.$router.replace({ path: "/" });
      }
    }
  },
  mounted() {
    this.init();
  },

  components: {}
};
</script>






// WEBPACK FOOTER //
// src/pages/user/LoginInit.vue